import React from 'react';
import utils from '../../../../utils';

/**
 * @export
 * @param {Object} def
 * @param {Boolean} linesHaveGroups
 *
 * @return {JSX}
 */
export default function LinesGroupHeader({def, linesHaveGroups}) {
	const debugMode = localStorage.getItem('debugMode') ? true : false;

	return (
		<thead className="linesGroupHeader">
			<tr>
				<th className="linesGroupHeader__icons"></th>
				{Object.keys(def)?.map((key) => {
					const column = def[key];
					if (!column.hidden) {
						return <th style={{width: column.width}} key={key}>
							{utils.translate(column.label)}
							{debugMode ? <><span className="debugName"> {column.fieldName}</span><span className="debugType"> {column.fieldType}</span></>  : null}
						</th>;
					}
				})}
				{linesHaveGroups && <th></th>}
			</tr>
		</thead>
	);
}